module.exports = __webpack_public_path__ + "img/97ee0e3.svg";